
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { Scan } from "lucide-react";
import { useAnalytics } from "@/hooks/use-analytics";

interface GmailSyncCardProps {
  onGmailConsent: () => void;
}

export const GmailSyncCard = ({ onGmailConsent }: GmailSyncCardProps) => {
  // Feature flag - set to false to hide the component
  const isGmailSyncEnabled = false;

  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();

  if (!isGmailSyncEnabled) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("newTrip.gmailSync")}</CardTitle>
        <CardDescription>{t("newTrip.gmailSyncDesc")}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button 
          onClick={() => {
            trackEvent('NewTrip', 'gmail_consent_click', 'Gmail Integration');
            onGmailConsent();
          }} 
          variant="outline" 
          className="w-full"
        >
          <Scan className="mr-2 h-4 w-4" />
          {t("newTrip.connectGmail")}
        </Button>
      </CardContent>
    </Card>
  );
};
